export default "__VITE_ASSET__c5d2897b__"